export default __webpack_public_path__ + "static/media/undo.231cad29.png";